import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { IJobActivityAuditLog } from './interfaces/job-activity-audit.interface';

@Injectable({
  providedIn: 'root'
})
export class JobActivityAuditService {
  private apiUrl = environment.baseApiUrl;

  constructor(private http: HttpClient) { }

  getJobActivityAuditLogs(jobId: number): Observable<IJobActivityAuditLog[]> {
    return this.http.get<IJobActivityAuditLog[]>(`${this.apiUrl}/jobs/prisma/JobActivityAuditLog/${jobId}`);
  }
}
